export default "__VITE_ASSET__d80b7a6b__";